import { useTranslation } from "react-i18next";
import { Language } from "iconoir-react";
import { LANGUAGES } from "@/i18n";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher({ dark = false }) {
  const { t, i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || "en");

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="language-switcher"
          className={`flex items-center gap-2 px-3 py-2 font-app text-sm uppercase tracking-widest transition-colors ${
            dark ? "text-bone/80 hover:text-bone" : "hover:text-intl"
          }`}
        >
          <Language width={16} height={16} />
          <span data-testid="language-current">{t(`lang.${current}`)}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" data-testid="language-menu">
        {LANGUAGES.map((lng) => (
          <DropdownMenuItem
            key={lng}
            data-testid={`language-option-${lng}`}
            onClick={() => i18n.changeLanguage(lng)}
            className={current === lng ? "font-bold text-intl" : ""}
          >
            {t(`lang.${lng}`)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
